interface ErrorConfig {
  eyebrow: string
  heading: string
  description: string
}

const ERROR_CONFIG: Record<number, ErrorConfig> = {
  400: {
    eyebrow: '400 Error',
    heading: '400 Error: Bad Request',
    description: 'The request could not be understood by the server.'
  },
  403: {
    eyebrow: '403 Error',
    heading: '403 Error: Access Denied',
    description: "You don't have permission to view this page."
  },
  404: {
    eyebrow: '404 Error',
    heading: '404 Error: Page not found',
    description: "We can't find that page, but we can still help."
  },
  500: {
    eyebrow: '500 Error',
    heading: '500 Error: Something went wrong',
    description: 'An unexpected error occurred. Please try again later.'
  },
  503: {
    eyebrow: '503 Error',
    heading: '503 Error: Service Unavailable',
    description: 'The server is unable to handle a request, but we can still help.'
  }
}

const DEFAULT_ERROR = ERROR_CONFIG[500]

const ErrorContent = ({ errorCode }: { errorCode?: number }) => {
  const { eyebrow, heading, description } = (errorCode && ERROR_CONFIG[errorCode]) || DEFAULT_ERROR
  return (
    <div className='aem-GridColumn aem-GridColumn--default--12'>
      <div className='aem-container aem-Grid aem-Grid--12 aem-Grid--default--12'>
        {/* Top spacing container */}
        <div className='aem-GridColumn aem-GridColumn--default--12'>
          <div data-testid='react-html' className='container top-spacing bottom-spacing' />
          <div />
        </div>

        {/* Teaser section */}
        <div className='aem-GridColumn aem-GridColumn--default--12'>
          <div data-testid='react-teaser-container' className='react-teaser-container container top-spacing cox-resi'>
            <div className='cmp-teaser' role='group' data-panelcontainer='teaser' aria-roledescription='teaser' />
            <div className='cmp-teaser__item cmp-teaser__item--active' role='tabpanel' data-cmp-hook-teaser='item'>
              <div>
                <div data-testid='react-content-fragment' className='react-content-fragment' />
                <div />
              </div>
            </div>
            <div className='react-standard-teaser-wrapper' id='reactcontentfragment-ddbaa26578'>
              <div
                data-testid='react-standard-teaser-container'
                className='react-standard-teaser-container'
                style={{ display: 'flex', flexDirection: 'row', width: '100%' }}
              >
                <div style={{ flex: '0 0 41.666%' }} />
                <div
                  className='react-standard-teaser-card standard-teaser-card whitelilac-background-variation'
                  style={{ flex: '0 0 58.333%', backgroundColor: '#eef1f4', padding: '3rem' }}
                >
                  <div className='teaser-top'>
                    <div
                      data-rte-editelement='true'
                      className='word-wrap rte eyebrow'
                      id='rich-text'
                      data-testid='rich-text-container'
                    >
                      <p
                        style={{
                          margin: '0 0 1rem',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          textTransform: 'uppercase',
                          letterSpacing: '0.08em',
                          color: '#111'
                        }}
                      >
                        {eyebrow}
                      </p>
                    </div>
                    <div
                      data-rte-editelement='true'
                      className='word-wrap rte heading'
                      id='rich-text'
                      data-testid='rich-text-container'
                    >
                      <p
                        style={{ margin: '0 0 1.25rem', fontSize: '2rem', fontWeight: 800, lineHeight: 1.15, color: '#111' }}
                      >
                        {heading}
                      </p>
                    </div>
                    <div
                      data-rte-editelement='true'
                      className='word-wrap rte description standard-description'
                      id='rich-text'
                      data-testid='rich-text-container'
                    >
                      <p style={{ margin: '0 0 2rem', fontSize: '1rem', fontWeight: 400, lineHeight: 1.5, color: '#222' }}>
                        {description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div />
        </div>

        {/* Links section */}
        <div className='aem-GridColumn aem-GridColumn--default--12'>
          <div data-testid='react-layout' className='react-layout container top-spacing bottom-spacing select'>
            <div className='sc-aXZVg fUuJzs row mobile-spacing false'>
              <div className='col-12 col-lg-6 d-flex flex-column align-items-start text-start'>
                <div>
                  <div className='container responsivegrid'>
                    <div className='cmp-container'>
                      <div className='aem-container' />
                    </div>
                  </div>
                  <div />
                </div>
              </div>
              <div className='col-12 col-lg-6 d-flex flex-column align-items-start text-start'>
                <div>
                  <div className='container responsivegrid'>
                    <div className='cmp-container'>
                      <div className='aem-container'>
                        <div>
                          <div
                            id='title-db9b09ab34'
                            data-testid='react-title'
                            className='react-title cox-text-heading1 select'
                          >
                            Spectrum Residential
                          </div>
                          <div />
                        </div>
                        <div>
                          <div
                            data-rte-editelement='true'
                            className='word-wrap rte atom-top-spacing atom-bottom-spacing select'
                            id='text-8fd7a4355d'
                            data-testid='text-8fd7a4355d-container'
                          >
                            <p>
                              <b>
                                <a href='/residential/support/home.html' target='_self' rel='noopener noreferrer'>
                                  Support
                                </a>
                                <br />
                                &nbsp;
                              </b>
                            </p>
                            <p>
                              <b>
                                <a href='/residential/home.html' target='_self' rel='noopener noreferrer'>
                                  Homepage
                                </a>
                                <br />
                                &nbsp;
                              </b>
                            </p>
                            <p>
                              <b>
                                <a href='/myaccount' target='_self' rel='noopener noreferrer'>
                                  My Account
                                </a>
                                <br />
                                &nbsp;
                              </b>
                            </p>
                            <p>
                              <b>
                                <a href='/residential/contactus.html' target='_self' rel='noopener noreferrer'>
                                  Contact Us
                                </a>
                                <br />
                                &nbsp;
                              </b>
                            </p>
                            <p>
                              <b>
                                <a href='/residential-shop/shop.html' target='_self' rel='noopener noreferrer'>
                                  Shop all offers
                                </a>
                              </b>
                            </p>
                            <p>&nbsp;</p>
                          </div>
                          <div />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div />
                </div>
              </div>
            </div>
          </div>
          <div />
        </div>

        {/* Bottom container */}
        <div className='aem-GridColumn aem-GridColumn--default--12'>
          <div className='aem-container aem-Grid aem-Grid--12 aem-Grid--default--12' />
          <div />
        </div>
      </div>
      <div />
    </div>
  )
}

export default ErrorContent
